// This file is auto-generated by update-translation-configuration script.
// Don't edit it manually, instead run `npm run update-translation-configuration`.

import adminBillingTranslations from '@/admin/billing/i18n/translations.en-GB.json';
import adminBrandingTranslations from '@/admin/branding/i18n/translations.en-GB.json';
import adminCategoriesTranslations from '@/admin/categories/i18n/translations.en-GB.json';
import adminCoursesTranslations from '@/admin/courses/i18n/translations.en-GB.json';
import adminEventsTranslations from '@/admin/events/i18n/translations.en-GB.json';
import adminGroupsTranslations from '@/admin/groups/i18n/translations.en-GB.json';
import adminTranslations from '@/admin/i18n/translations.en-GB.json';
import adminIntegrationsTranslations from '@/admin/integrations/i18n/translations.en-GB.json';
import adminIntegrationsOpenSesameTranslations from '@/admin/integrations/open-sesame/i18n/translations.en-GB.json';
import adminLoggingTranslations from '@/admin/logging/i18n/translations.en-GB.json';
import adminPlaylistsTranslations from '@/admin/playlists/i18n/translations.en-GB.json';
import adminRolesTranslations from '@/admin/roles/i18n/translations.en-GB.json';
import adminSettingsTranslations from '@/admin/settings/i18n/translations.en-GB.json';
import adminSkillsTranslations from '@/admin/skills/i18n/translations.en-GB.json';
import adminTopicsTranslations from '@/admin/topics/i18n/translations.en-GB.json';
import adminUsersTranslations from '@/admin/users/i18n/translations.en-GB.json';
import authenticationTranslations from '@/authentication/i18n/translations.en-GB.json';
import commonComponentsTranslations from '@/common/components/i18n/translations.en-GB.json';
import commonTranslations from '@/common/i18n/translations.en-GB.json';
import contentStoreTranslations from '@/content-store/i18n/translations.en-GB.json';
import conversationsActionItemsTranslations from '@/conversations/action-items/i18n/translations.en-GB.json';
import conversationsDocumentsNotesTranslations from '@/conversations/documents/notes/i18n/translations.en-GB.json';
import conversationsDocumentsTalkingPointsTranslations from '@/conversations/documents/talking-points/i18n/translations.en-GB.json';
import conversationsTranslations from '@/conversations/i18n/translations.en-GB.json';
import coursesTranslations from '@/courses/i18n/translations.en-GB.json';
import eventsTranslations from '@/events/i18n/translations.en-GB.json';
import impersonationTranslations from '@/impersonation/i18n/translations.en-GB.json';
import instructorsEventsOverviewTranslations from '@/instructors/i18n/events-overview/translations.en-GB.json';
import managersTranslations from '@/managers/i18n/translations.en-GB.json';
import managersManagerGroupConversationsTranslations from '@/managers/manager-group-conversations/i18n/translations.en-GB.json';
import notificationsTranslations from '@/notifications/i18n/translations.en-GB.json';
import openInAppTranslations from '@/open-in-app/i18n/translations.en-GB.json';
import personalSpaceTranslations from '@/personal-space/i18n/translations.en-GB.json';
import profileSettingsTranslations from '@/profile-settings/i18n/translations.en-GB.json';
import reportingCommonTranslations from '@/reporting/common/i18n/translations.en-GB.json';
import reportingCoursesCoursesTranslations from '@/reporting/courses/courses/i18n/translations.en-GB.json';
import reportingEventsEventsTranslations from '@/reporting/events/events/i18n/translations.en-GB.json';
import reportingGroupsTranslations from '@/reporting/groups/i18n/translations.en-GB.json';
import reportingPlaylistsTranslations from '@/reporting/playlists/i18n/translations.en-GB.json';
import reportingSegmentsTranslations from '@/reporting/segments/i18n/translations.en-GB.json';
import reportingSkillsTranslations from '@/reporting/skills/i18n/translations.en-GB.json';
import reportingUsersTranslations from '@/reporting/users/i18n/translations.en-GB.json';

import { mergeTranslations } from '@/common/services';

export default mergeTranslations(
    adminBillingTranslations,
    adminBrandingTranslations,
    adminCategoriesTranslations,
    adminCoursesTranslations,
    adminEventsTranslations,
    adminGroupsTranslations,
    adminIntegrationsOpenSesameTranslations,
    adminIntegrationsTranslations,
    adminLoggingTranslations,
    adminPlaylistsTranslations,
    adminRolesTranslations,
    adminSettingsTranslations,
    adminSkillsTranslations,
    adminTopicsTranslations,
    adminTranslations,
    adminUsersTranslations,
    authenticationTranslations,
    commonComponentsTranslations,
    commonTranslations,
    contentStoreTranslations,
    conversationsActionItemsTranslations,
    conversationsDocumentsNotesTranslations,
    conversationsDocumentsTalkingPointsTranslations,
    conversationsTranslations,
    coursesTranslations,
    eventsTranslations,
    impersonationTranslations,
    instructorsEventsOverviewTranslations,
    managersManagerGroupConversationsTranslations,
    managersTranslations,
    notificationsTranslations,
    openInAppTranslations,
    personalSpaceTranslations,
    profileSettingsTranslations,
    reportingCommonTranslations,
    reportingCoursesCoursesTranslations,
    reportingEventsEventsTranslations,
    reportingGroupsTranslations,
    reportingPlaylistsTranslations,
    reportingSegmentsTranslations,
    reportingSkillsTranslations,
    reportingUsersTranslations
);
